/*
 * @Description: workOrder
 * @Autor: dengyongliang
 * @Date: 2021-04-27 09:30:44
 * @LastEditors: dengyongliang
 * @LastEditTime: 2021-07-01 09:18:51
 */
'use strict'
import axios from '@/global/axios.js'
import * as action from '@/actions/workOrder'

// 工单管理
export const WORK_ORDER_MANAGE = (pageNum, pageSize) => {
  return axios({
    url: action.WORK_ORDER_MANAGE,
    method: 'POST',
    data: { pageNum, pageSize }
  })
}
// 工单提交
export const WORK_ORDER_SUBMIT = (money, securityType, orderCode, updateType, questionType, domainName, description) => {
  return axios({
    url: action.WORK_ORDER_SUBMIT,
    method: 'POST',
    data: { money, securityType, orderCode, updateType, questionType, domainName, description }
  })
}
// 工单详情
export const WORK_ORDER_DETAIL = id => {
  return axios({
    url: action.WORK_ORDER_DETAIL,
    method: 'POST',
    data: { id }
  })
}



// WEBPACK FOOTER //
// ./src/api/workOrder.js